"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRestoreFocus = useRestoreFocus;
exports.default = void 0;

var _react = require("react");

function useRestoreFocus() {
  const [previouslyFocusedEl, setPreviouslyFocusedEl] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      setPreviouslyFocusedEl(document.activeElement);
    }
  }, [setPreviouslyFocusedEl]);
  (0, _react.useEffect)(() => () => {
    if (typeof previouslyFocusedEl !== 'undefined') {
      previouslyFocusedEl.focus();
    }
  }, [previouslyFocusedEl]);
}

var _default = useRestoreFocus;
exports.default = _default;
//# sourceMappingURL=useRestoreFocus.js.map